import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M32 0H0V32H32V0Z",
      class: "bg",
      fill: "#D7DBF7"
    }, null, -1),
    _createElementVNode("path", {
      d: "M24 13.333V23.9997C24 24.7069 23.719 25.3852 23.219 25.8853C22.7189 26.3854 22.0406 26.6663 21.3333 26.6663H10.6667C9.95942 26.6663 9.28115 26.3854 8.78105 25.8853C8.28095 25.3852 8 24.7069 8 23.9997V7.99967C8 7.29243 8.28095 6.61415 8.78105 6.11406C9.28115 5.61396 9.95942 5.33301 10.6667 5.33301H16V10.6663C16 11.3736 16.281 12.0519 16.781 12.552C17.2811 13.0521 17.9594 13.333 18.6667 13.333H24Z",
      class: "primary",
      fill: "#151F6D"
    }, null, -1),
    _createElementVNode("path", {
      d: "M24 13.333H18.6667C17.9594 13.333 17.2811 13.0521 16.781 12.552C16.281 12.0519 16 11.3736 16 10.6663V5.33301L24 13.333Z",
      class: "secondary",
      fill: "#959FEB"
    }, null, -1)
  ])))
}
export default { render: render }